<template>
  <base-section
    id="theme-features"
  >
    <base-section-heading title="Welcome">
      ETS2023 will be held in Saint Servolo Island (Isola di San Servolo in Italian), located a few minutes by ferry-boat from Piazza San Marco, in Venice. The format of the conference will be <strong>hybrid</strong>. The program includes keynotes, scientific paper presentations, panels, tutorials, workshops, and highlights/demos from the industry.
    </base-section-heading>
    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <router-link
            v-if="feature.to != ''"
            style="text-decoration: none !important;"
            :to="feature.to"
          >
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            />
          </router-link>
          <base-avatar-card
            v-if="feature.to == ''"
            v-bind="feature"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
    <base-section-heading title="Topics">
      The list of the topics (not limited to) for ETS'23.
      <br>
      • <strong>Dependable AI and AI for Testing (Hot Topic)</strong><br>
      • <strong>Functional Safety and Reliability in Automotive (Hot Topic)</strong><br>
      • <strong>Emerging technologies and architectures (Hot Topic)</strong><br>
      • <strong>Security and Trust (Hot Topic)</strong><br>
      • <strong>Analog, Mixed-Signal, RF</strong><br>
      • <strong>DfT and Test Access Standards</strong><br>
      • <strong>Validation, Verification Debug and Diagnosis</strong><br>
      • <strong>Test generation, Fault Simulation, Fault Tolerance, Application and Evaluation</strong><br>
      • <strong>Special Track on Dependable RISC-V</strong><br>
      • <strong>Special Track on Dependable Autonomous Systems</strong><br>
      <br>
      You can find the description and the subtopics in:
      <br>
      <br>
      <v-btn
          href="#/program#tab-topics"
          target="_parent"
          rounded
          color="primary"
          dark
          style="padding: 15px"
          class="hidden-sm-and-down"
        >
          <v-icon
            left
            dark
          >
            mdi-open-in-new
          </v-icon>
          Topics
        </v-btn>
        <v-btn
          href="#/topics"
          target="_parent"
          rounded
          color="primary"
          dark
          style="padding: 15px"
          class="hidden-md-and-up"
        >
          <v-icon
            left
            dark
          >
            mdi-open-in-new
          </v-icon>
          Topics
        </v-btn>
        <br>
        <br>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'Contributions from all around the globe',
          icon: 'mdi-account-group',
          text: 'Everyone all around the globe is welcome to contribute to the conference with their research and recent works',
          to: 'cfp',
        },
        {
          title: 'Important Industrial Partners',
          icon: 'mdi-factory',
          text: 'Industries from all over the world will participate',
          to: 'industrial',
        },
        {
          title: 'Academic Networking',
          icon: 'mdi-school',
          text: 'Joining ETS conference is an opportunity know new people and get insights for future research',
          to: 'cfp',
        },
        {
          title: 'Student Activities',
          icon: 'mdi-account-school',
          text: 'It is a great chance for PhD students to keep updated with the last hot topics about testing. There are possibilities to share their progress as PhD students through PhD forum and McClunksey Award. Also, the site about Test Spring School 2023 will be available soon!',
          to: 'student-activities',
        },
      ],
    }),
  }
</script>
